import { render, staticRenderFns } from "./offers.vue?vue&type=template&id=dd0fd24a&scoped=true"
import script from "./offers.vue?vue&type=script&lang=js"
export * from "./offers.vue?vue&type=script&lang=js"
import style0 from "./offers.vue?vue&type=style&index=0&id=dd0fd24a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0fd24a",
  null
  
)

export default component.exports